import api from './api';

const resource = 'Terms/';

export const list = async (params = {}) => {
  const query = new URLSearchParams({
    PageNumber: params.PageNumber ?? 1,
    PageSize: params.PageSize ?? 100,
    ...params,
  }).toString();
  return await api.get(resource + `List?${query}`);
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const getByName = async (name) => {
  if (!name) return { data: { data: null } };
  return await api.get(resource + 'GetByName?name=' + encodeURIComponent(name));
};

export const upsert = async (body) => {
  return await api.post(resource + 'Upsert', body);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

const termsApi = { list, getById, getByName, upsert, deleteById };

export default termsApi;
